import useResource from 'app/hooks/useResource';

// keeping the customers resource for guests
import {
  customers as resource
} from 'app/resources';

import {
  getGuests,
  setGuestParams
} from 'app/actions/guests';

// keeping customers CRUD services for guests
import {
  createCustomer,
  updateCustomer,
  destroyCustomers
} from 'app/services/customers';

const useGuests = (props = {}) => {
  const {
    onCreate
  } = props;

  return useResource({
    resource,
    getResource: getGuests,
    createResource: createCustomer,
    updateResource: updateCustomer,
    destroyResource: destroyCustomers,
    setResourceParams: setGuestParams,
    onCreate
  });
}

export default useGuests;
